import server from "./server";

export const getAdminsApi = async () => {
  const response = await server().get("/users");
  return response.data;
};

export const getAdminApi = async ({ id }) => {
  const response = await server().get(`/users/${id}`);
  return response.data;
};

export const createAdminApi = async ({ data }) => {
  const response = await server().post("/users", data);
  return response.data;
};

export const updateAdminApi = async ({ id, data }) => {
  const response = await server().put(`/users/${id}`, data);
  return response.data;
};

export const deleteAdminApi = async ({ id }) => {
  const response = await server().delete(`/users/${id}`);
  return response.data;
};
